import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";

import { useDispatch, useSelector } from "react-redux";
import OverallWidget from "./OverallWidget";
import LocationWidget from "./LocationWidget";
import Select, { components } from "react-select";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";

const DashboardEcommerce = () => {
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [rightFilter, setRightFilter] = useState({"label":"This Month","value":"ThisMonth"});

  const [comparisonDate, setComparisonDate] = useState([]);
 
  const [refresh, setRefresh] = useState(false);
  

  const handleRefresh = () => {
    // setRecalculate(!recalculate);
    setRefresh(!refresh);
  }

   const [mealPeriod, setMealPeriod] = useState([]);
    const [filtermealperiod, setFiltermealperiod] = useState([]);
    const [filterDateList, setFilterDateList] = useState([]);
    const [currency, setCurrency] = useState(null);
    const [selectedMealList, setSelectedMealList] = useState(["all"]);
    const changeMealPeriod = (value) => {
      setSelectedMealList(value);
      // let selVal= [];
      // value.map((item) => {
      //   selVal.push(item.value);
      // });
      // setMealPeriod(selVal);
      if (value==="all") {
        setMealPeriod([]);
      } else {
        setMealPeriod([value]);
      }
    };
    const {
      filterData,
      filterAjax,
      currentOutlet
    } = useSelector((state) => ({
      filterData: state.Dashboard.filterData,
      filterAjax: state.Dashboard.filterAjax,
      currentOutlet:state.UserOutletGroup.currentOutlet
    }));
  
    const [leftFilter, setLeftFilter] = useState(
      filterData.flash_date?.find((date) => date.default) || false
    );
  
    useEffect(() => {  
      if (filterData.mealperiod) {
        const mealListArr = [];
        filterData.mealperiod.map((item) => {
          mealListArr.push({
            value: item.sp_id,
            //label: item.title + ' (' + item.start_time + ' To ' + item.end_time +')'
            label: item.title
          });
        });
        mealListArr.push({
          value: "all",
          label: "All Meal"
        });
  
        setFiltermealperiod(mealListArr);
        //setFiltermealperiod(filterData.mealperiod);
      }
      if (filterData.flash_date) {
        setLeftFilter((prev) =>
          prev || filterData.flash_date.find((date) => date.default)
        );
        setFilterDateList(filterData.flash_date);
      }
    }, [filterAjax, filterData]);  
    // useEffect(()=>{
    //   if(currentOutlet?.currency!=""){
    //     setCurrency(currentOutlet?.currency)
    //   }
    // },[currentOutlet]);



  let date = new Date();
  date.setDate(date.getDate() - 1);
  
    // const getMealString = (selectedMealList) => {
    //   if (!selectedMealList || selectedMealList.length === 0) {
    //     return "All Meal";
    //   }  
    //   return selectedMealList.map((meal) => meal.label.split(" (")[0]).join(", ");
    // };
    // const mealString = getMealString(selectedMealList);
  
    const CustomOption = (props) => {
      return (
        <components.Option {...props}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ verticalAlign: "middle" }} />
          <span style={{ verticalAlign: "middle", lineHeight: 1 }}>{props.data.label}</span >
          </div>
        </components.Option>
      );
    };

    const toggleMeal = (meal) => {
      // setSelectedMealList((prev) =>
      //   prev.includes(meal)
      //     ? prev.filter((m) => m !== meal)
      //     : [...prev, meal]
      // );
      changeMealPeriod(meal); // Update parent handler
    };

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Restaurant Analytics" pageTitle="Dashboard" activeDate={leftFilter} customDate={leftCustomDate} handleRefresh={handleRefresh}   />                              
      
          <form className="mb-3">
            <Row>
              <Col className="mb-2 mb-lg-0 ps-0" sm={12} lg={2}>
                <FlashDatePicker
                  filterDateList={filterDateList}
                  activeDate={leftFilter}
                  setActiveDate={setLeftFilter}
                  posEnd={false}
                  menuWidth="170px"
                />
              </Col>
              <Col className="mb-2 mb-lg-0 ps-0" sm={12} lg={4}></Col>
              {/* <Col sm={12} lg={4}>
                <Select
                    value={selectedMealList}
                    isMulti={true}
                    onChange={(value) => {
                      changeMealPeriod(value);
                    }}
                    options={filtermealperiod}
                    placeholder="All Meal Periods"
                    closeMenuOnSelect={false}
                    components={{ Option: CustomOption }}
                  />
              </Col> */}
              <Col sm={12} lg={6}>
                <div className="d-flex flex-wrap gap-2 justify-content-end">
                  {filtermealperiod.map((meal) => (
                    <Button
                      key={meal.value}
                      color={selectedMealList.includes(meal.value) ? "info" : "outline-info"}
                      onClick={() => toggleMeal(meal.value)}
                    >
                      {meal.label}
                    </Button>                    
                  ))}
                </div>
              </Col>
            </Row>
          </form>

          <Row>
            <Col>
              <div className="h-100">
                 {/* <Col xl={12}>
                    {currency ? (
                      <OverallWidget
                        mealPeriod={mealPeriod}
                        leftFilter={leftFilter}
                        currency={currency}
                      />
                    ) : (
                      <div>Loading...</div>
                    )}
                </Col> */}
                
                <Col xl={12}>
                    <LocationWidget mealPeriod={mealPeriod} leftFilter={leftFilter} setCurrency={setCurrency} />
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
